import { render, staticRenderFns } from "./Installment.vue?vue&type=template&id=1b585081&"
import script from "./Installment.vue?vue&type=script&lang=js&"
export * from "./Installment.vue?vue&type=script&lang=js&"
import style0 from "./Installment.vue?vue&type=style&index=0&id=1b585081&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports